import {Component, OnInit, Output, EventEmitter} from '@angular/core';
import {
    NgForm,
    FormGroup,
    FormControl,
    FormArray,
    Validators,
    ValidatorFn,
    AsyncValidatorFn
} from '@angular/forms';
import {FormInlineRowComponent} from './../forms/form-inline-row';
import {MessageComponent, BaseComponent} from '../common/common-components';
import {DictionaryService} from "../services/dictionary-service";
import {MessageService} from "../services/message-service";
import {WalletService} from "./wallet-service";

let _ : any = require("lodash");

@Component({
    selector: 'dk-wallet-transaction',
    inputs: ['transaction'],
    template: require('./wallet-transaction.html'),
    entryComponents: [],
})

export class WalletTransactionComponent extends BaseComponent {
    transaction: any;

    constructor () {
        super();
    }

    public get getFXCurrencySymbol(): any {
        var result = this.transaction.ExchangeCurrencySymbol == "PLN" 
            || (this.transaction.ExchangeCurrencySymbol != "PLN" && this.transaction.CurrencySymbol != "PLN")? this.transaction.CurrencySymbol : this.transaction.ExchangeCurrencySymbol;
        return result;
    }

    public get getSrcCurrencySymbol(): any {
        var result = this.transaction.ExchangeCurrencySymbol == "PLN" 
            || (this.transaction.ExchangeCurrencySymbol != "PLN" && this.transaction.CurrencySymbol != "PLN")? this.transaction.ExchangeCurrencySymbol : this.transaction.CurrencySymbol;
        return result;
    }
}

